import { useMemo } from 'react';
import {
  Feature,
  OfferType,
  ShortOfferDto,
  useCapabilitiesOffers,
} from '@app/api';
import { UpsellSubscriptionModal } from './UpsellSubscriptionModal';
import { UpsellOptionModal } from './UpsellOptionModal';

interface Props {
  isOpen: boolean;
  onRequestClose: () => void;
  feature?: Feature | boolean;
}

export const UnlockFeatureModal = ({
  isOpen,
  onRequestClose,
  feature,
}: Props) => {
  const { data: capabilitiesOffers } = useCapabilitiesOffers();
  const featureCapabilitiesOffers =
    feature && feature !== true && capabilitiesOffers
      ? capabilitiesOffers[feature]
      : undefined;

  const firstOfferByType = useMemo(() => {
    if (!featureCapabilitiesOffers) {
      return {} as Record<OfferType, ShortOfferDto>;
    }
    return featureCapabilitiesOffers.offers.reduce((acc, o) => {
      if (acc[o.type]) {
        return acc;
      }
      acc[o.type] = o;
      return acc;
    }, {} as Record<OfferType, ShortOfferDto>);
  }, [featureCapabilitiesOffers]);

  if (firstOfferByType[OfferType.OPTION]) {
    return (
      <UpsellOptionModal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        offer={firstOfferByType[OfferType.OPTION]}
      />
    );
  }

  if (firstOfferByType[OfferType.SUBSCRIPTION] || feature === true) {
    return (
      <UpsellSubscriptionModal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        feature={feature}
      />
    );
  }
  return null;
};
